import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { router } from './router'
import '@fontsource-variable/inter'
import './styles/globals.css'

import debug from 'debug'

declare global {
	interface Window {
		app: {
			debug: {
				enable: (ns?: string) => void
			}
		}
	}
}

window.app = {
	debug: {
		enable(ns: string = 'app:*') {
			debug.enable(ns)
		},
	},
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>,
)
